import React from 'react';

const TutorialsTunnel = () => <div />;

export default TutorialsTunnel;
